import { forwardRef, Ref } from 'react'
import TextField, { TextFieldProps } from 'components/TextField'
import InputBaseMask, { InputBaseMaskProps } from 'components/Input/InputBaseMask'

export type TextFieldNumberProps = TextFieldProps & InputBaseMaskProps & {}

const TextFieldNumber = function TextMaskCustom(props: TextFieldNumberProps, ref: Ref<any>) {
  const {
    // iMask
    autofix,
    blocks,
    definitions,
    eager,
    format,
    lazy,
    mask,
    max,
    min,
    overwrite,
    pattern,
    placeholderChar,
    scale,
    signed,

    //
    inputProps,
    InputProps,
    color,
    // defaultValue,
    error,
    fullWidth,
    helperText,
    className,
    label,
    placeholder,
    onBlur,
    onChange,
    onFocus,
    value = '',
    variant,
    disabled
  } = props

  const hasMaskProp =
    autofix ||
    blocks ||
    definitions ||
    eager ||
    format ||
    lazy ||
    mask ||
    max ||
    min ||
    overwrite ||
    pattern ||
    placeholderChar ||
    scale ||
    signed

  const inputPropsAdjusted =
    (!inputProps && hasMaskProp) || inputProps
      ? {
          ...inputProps,
          autofix,
          blocks,
          definitions,
          eager,
          format,
          lazy,
          mask,
          max,
          min,
          overwrite,
          pattern,
          placeholderChar,
          scale,
          signed
        }
      : undefined

  return (
    <TextField
      ref={ref}
      color={color}
      className={className}
      fullWidth={fullWidth}
      label={label}
      value={value}
      disabled={disabled}
      onBlur={onBlur}
      onChange={onChange}
      onFocus={onFocus}
      error={error}
      helperText={helperText}
      inputProps={inputPropsAdjusted}
      InputProps={{
        ...InputProps,
        inputComponent: InputBaseMask as any
      }}
      placeholder={placeholder}
      variant={variant}
    />
  )
}

export default forwardRef(TextFieldNumber)
